import { DialogManagerClientFinsembleImpl } from "./finsembleImplementation";
import { DialogManagerClientGlueImpl } from "./glueImplementation";
import { FINSEMBLECONFIG } from "../common/windowFunctions";
export class DialogManagerClientImpl {
    constructor(gluePromise, asyncConstructors, router, appsClient, distributedStoreClient, Logger) {
        this.gluePromise = gluePromise;
        this.asyncConstructors = asyncConstructors;
        this.finsembleImplementation = new DialogManagerClientFinsembleImpl(gluePromise, asyncConstructors, router, appsClient, distributedStoreClient, Logger);
        this.glueImplementation = new DialogManagerClientGlueImpl(gluePromise, asyncConstructors, Logger);
    }
    set userInputTimeout(timeout) {
        this.finsembleImplementation.userInputTimeout = timeout;
    }
    get openerMessage() {
        return this.finsembleImplementation.openerMessage ?? null;
    }
    async sendQueryToDialog(identifier, options, onUserInput) {
        return this.finsembleImplementation.sendQueryToDialog(identifier, options, onUserInput);
    }
    async hideModal() {
        return null;
    }
    async showModal() {
        return null;
    }
    async spawnDialog(params, inputParams, dialogResponseCallback, cb) {
        return this.finsembleImplementation.spawnDialog(params, inputParams, dialogResponseCallback, cb) ?? {};
    }
    async useGlueDialogs() {
        const glue = await this.gluePromise;
        const manifest = await glue.contexts.get(FINSEMBLECONFIG) ?? {};
        return manifest?.iocd?.iocdDialogs === true;
    }
    async open(type, options, onUserInput) {
        const useGlueDialogs = await this.useGlueDialogs();
        if (useGlueDialogs) {
            return this.glueImplementation.open(type, options, onUserInput) ?? null;
        }
        else {
            return this.finsembleImplementation.open(type, options, onUserInput) ?? null;
        }
    }
    async getParametersFromInDialog() {
        return this.finsembleImplementation.getParametersFromInDialog();
    }
    async respondAndExitFromInDialog(responseParameters) {
        return this.finsembleImplementation.respondAndExitFromInDialog(responseParameters);
    }
    async showDialog() {
        return this.finsembleImplementation.showDialog();
    }
    async registerDialogCallback(cb) {
        return this.finsembleImplementation.registerDialogCallback(cb);
    }
    async respondToOpener(data) {
        return this.finsembleImplementation.respondToOpener(data);
    }
}
